import React, { useEffect, useState } from "react";
import "./Investigators.css";
import Container from "react-bootstrap/Container";
import { Row, Col } from "react-bootstrap";
import Sidebar from "../../components/Sidebar/Sidebar";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import "@progress/kendo-theme-default/dist/all.css";
import { GetInvestigatorData } from "../../apis/InvestigatorAPI";

export default function AdminInvestigators() {
  const [investigatorData, setInvestigatorData] = useState([]);

  useEffect(() => {
    async function GetInvestigatorList() {
      var result = await GetInvestigatorData();
      var data = result.data;
      setInvestigatorData(data);
    }
    GetInvestigatorList();
  }, []);

  const customCell = (status) => {
    var st = status ? "Active" : "Disabled";
    return (
      <td
        colspan="1"
        class=""
        role="gridcell"
        aria-colindex="3"
        aria-selected="false"
        data-grid-col-index="3"
      >
        {st}
      </td>
    );
  };

  return (
    <>
      <Container fluid>
        <Row>
          <div className="admin-wrapper">
            <div className="left-section">
              <Sidebar />
            </div>
            <div className="right-section">
              <Container fluid>
                <Row className="admin-page-row orders">
                  <Col lg={6} md={6} sm={12}>
                    <div className="page-title">
                      <h2>Investigators</h2>
                    </div>
                  </Col>
                  <Col lg={6} md={6} sm={12}>
                    <div className="search-filter"></div>
                  </Col>
                </Row>
                <Row>
                  <Grid style={{ height: "75vh" }} data={investigatorData}>
                    <GridColumn field="id" title="ID" width="70px" />
                    <GridColumn field="investigatorName" title="Name" />
                    <GridColumn
                      field="investigatorEmail"
                      title="Email"
                      width="250px"
                    />
                    <GridColumn
                      field="status"
                      title="Status"
                      cell={(props) => customCell(props.dataItem.status)}
                    />
                    <GridColumn field="newOrderCount" title="New Order" />
                    <GridColumn
                      field="inProgressCount"
                      title="Order In Progress"
                    />
                    <GridColumn field="prelimCount" title="Order In Prelim" />
                    <GridColumn
                      field="completedCount"
                      title="Completed Order"
                    />
                  </Grid>
                </Row>
              </Container>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
}
